
/* injects from baggage-loader */
require('./pando-process-claim-info.component.html');

import angular from 'angular';


angular.module('AaApp.Opp').component('pandoProcessClaimInfo', {
    templateUrl: '/app/components/deal-sheet/pando-process-claim-info.component.html',
    controller: ProcessClaimInfoController,
    bindings: {
        claimInfo:'<',
    }
});

/* @ngInject */
function ProcessClaimInfoController() {
    var $ctrl = this;
    $ctrl.dateSeparator = ": ";
}